import {
  Baby, Briefcase, Car, ChefHat, Coins, Dice5, Dog, Dumbbell, Film,
  GraduationCap, Hammer, Heart, Home, Laptop, Plane, Shirt, ShoppingCart,
  Sparkles, Stethoscope, TrendingUp, Utensils, Tag,
} from '@digital-twins/design-system/icons'
import type { IconComponent } from '@digital-twins/design-system/icons'

/**
 * Industry taxonomy tier-1 categories mapped to display icons.
 *
 * Keyed by the canonical tier-1 `name` (first segment of `fullPath`).
 * The display name matches the taxonomy name directly — no remapping needed.
 *
 * Categories NOT in this map are still displayed but get the fallback icon.
 */
export const INDUSTRY_CATEGORIES: Record<string, { displayName: string; icon: IconComponent }> = {
  'Food & Beverage':            { displayName: 'Food & Beverage',            icon: Utensils },
  'Beauty & Personal Care':     { displayName: 'Beauty & Personal Care',     icon: Sparkles },
  'Health & Wellness':          { displayName: 'Health & Wellness',          icon: Heart },
  'Household & Home Care':      { displayName: 'Household & Home Care',      icon: Home },
  'Fashion & Apparel':          { displayName: 'Fashion & Apparel',          icon: Shirt },
  'Consumer Electronics':       { displayName: 'Consumer Electronics',       icon: Laptop },
  'Automotive':                 { displayName: 'Automotive',                 icon: Car },
  'Technology & Software':      { displayName: 'Technology & Software',      icon: Laptop },
  'Financial Services':         { displayName: 'Financial Services',         icon: Coins },
  'Healthcare & Pharma':        { displayName: 'Healthcare & Pharma',        icon: Stethoscope },
  'Professional Services':      { displayName: 'Professional Services',      icon: Briefcase },
  'Industrial & Manufacturing': { displayName: 'Industrial & Manufacturing', icon: Briefcase },
  'Media & Advertising':        { displayName: 'Media & Advertising',        icon: Film },
  'Telecom & Connectivity':     { displayName: 'Telecom & Connectivity',     icon: Laptop },
  'Energy & Utilities':         { displayName: 'Energy & Utilities',         icon: TrendingUp },
  'Education & EdTech':         { displayName: 'Education & EdTech',         icon: GraduationCap },
  'Real Estate & Construction': { displayName: 'Real Estate & Construction', icon: Home },
  'Travel & Hospitality':       { displayName: 'Travel & Hospitality',       icon: Plane },
  'Pet Care':                   { displayName: 'Pet Care',                   icon: Dog },
  'Restaurants & Foodservice':  { displayName: 'Restaurants & Foodservice',  icon: ChefHat },
  'Home & Garden':              { displayName: 'Home & Garden',              icon: Hammer },
  'Retail & E-commerce':        { displayName: 'Retail & E-commerce',        icon: ShoppingCart },
  'Toys, Kids & Family':        { displayName: 'Toys, Kids & Family',        icon: Baby },
  'Sports & Outdoors':          { displayName: 'Sports & Outdoors',          icon: Dumbbell },
  'Gambling & Sports Betting':  { displayName: 'Gambling & Sports Betting',  icon: Dice5 },
}

export const INDUSTRY_FALLBACK_ICON = Tag

export function getIndustryDisplayName(name: string): string {
  return INDUSTRY_CATEGORIES[name]?.displayName ?? name
}

/**
 * Resolve icon from the tier-1 ancestor.
 * Accepts either a tier-1 name directly or a full pipe-delimited path.
 */
export function getIndustryIcon(tier1Name: string): IconComponent {
  return INDUSTRY_CATEGORIES[tier1Name]?.icon ?? INDUSTRY_FALLBACK_ICON
}

export function isVisibleCategory(name: string): boolean {
  return name in INDUSTRY_CATEGORIES
}
